import React, { ReactNode } from 'react'

import Link from 'components/Link/Link'

interface SearchResultCardProps {
  slug: string
  children: ReactNode
  onClick: () => void
  extraLinkProps?: Record<string, unknown>
}

const SearchResultCard = (props: SearchResultCardProps): JSX.Element => {
  const { slug, children, onClick, extraLinkProps = {} } = props

  return (
    <Link href={`/profile/${slug}`}>
      <a
        data-cy="profileCard"
        aria-hidden
        onClick={onClick}
        {...extraLinkProps}
      >
        {children}
      </a>
    </Link>
  )
}

export default SearchResultCard
